<div
  class="list-item d-flex aling-items-center gpy-12 gpy-sm-16 text-secondary"
  [ngClass]="['rt1-regular' | gpuMediaQuery: 'rt2-regular', itemClass]"
>
  <div [class.gmr-16]="icon">
    <ng-content select="app-list-item-icon"></ng-content>
  </div>

  <div class="d-flex flex-column justify-content-center">
    <ng-content select="app-list-item-title"></ng-content>
    <p class="rl1-regular text-muted mb-0" [class.gpt-2]="description">
      <ng-content select="app-list-item-description"></ng-content>
    </p>
  </div>

  <div class="d-flex align-items-center ms-auto">
    <ng-content select="app-list-item-content"></ng-content>
  </div>
</div>
